// tslint:disable-next-line:no-empty
export const Noop = () => { };

export const parseUtmSource = (defaultValue: string) => {
	const match = window.location.hash.match(/utm_source=\w*/g);
	let source = defaultValue;
	if (!!match && match.length > 0) {
		const kvp = match[0].split('=');
		if (!!kvp && kvp.length === 2) {
			source = kvp[1];
		}
	}

	return source.toLowerCase();
};
